module.exports = __webpack_public_path__ + "img/job_record.605ca8e5.png";